import StepNumber from "./StepNumber";

export default StepNumber;
